import { getAdminAreaByIdApi } from "@/api/adminArea/adminAreaApi";
import { optimizeSelectValue } from "@/api/configuration/useConfigurationAPI";
import { AnalysisConfigurationDetail } from "@/types/project";

export const getAreaInputAdmAreaIds = (
  configurationDetail: AnalysisConfigurationDetail
): string[] | undefined => {
  const areaInput = configurationDetail.area_input;
  return (
    areaInput?.adm_area_ids ??
    (areaInput?.adm_area_id ? [areaInput.adm_area_id] : undefined)
  );
};

export const enhanceWithAdminAreaData = async (
  adm_area_ids: string[],
  isAdminTreeEnabled: boolean
): Promise<AnalysisConfigurationDetail["adminAreaData"]> => {
  const idsToFetch = isAdminTreeEnabled ? adm_area_ids : [adm_area_ids[0]];

  const adminAreaDetails = (
    await Promise.all(idsToFetch.map((id) => getAdminAreaByIdApi(id)))
  ).filter(Boolean);

  if (adminAreaDetails.length === 0) {
    return;
  }

  // Use the first admin area detail to generate the selectValue,
  // as it represents the hierarchical selection.
  const selectValue = optimizeSelectValue(adminAreaDetails[0]);

  return {
    selectValue,
    geoData: {
      data: adminAreaDetails
    }
  };
};
